import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { WebRTCCallState } from '../../core/services/webrtc-call.service';
@Component({
  selector: 'ai-sticky-footer',
  imports: [
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    AiAssistantI18nModule,
    GalaxyStickyFooterModule,
    GalaxyBadgeModule,
    GalaxyTooltipModule,
  ],
  templateUrl: './sticky-footer.component.html',
  styleUrl: './sticky-footer.component.scss',
})
export class StickyFooterComponent {
  readonly submitClick = output<void>();
  readonly cancelClick = output<void>();
  readonly callClick = output<void>();
  readonly endCallClick = output<void>();
  readonly cancelLink = input<string>();
  readonly disabled = input(false);
  readonly submitOverride = input<string>();
  readonly cancelOverride = input<string>();
  readonly hideCancel = input(false);
  readonly showUnsavedChangesIndicator = input(false);
  readonly showCallButton = input(false);
  readonly callDisabled = input(false);
  readonly callDisabledTooltip = input('');
  readonly callState = input<WebRTCCallState>('idle');
}
